import { ClockIcon } from '@phosphor-icons/react';
import { TimePicker as AntdTimePicker } from 'antd';
import type { ComponentProps } from 'react';

import styles from './date-picker.module.scss';

export type TimePickerProps = Omit<ComponentProps<typeof AntdTimePicker>, 'suffixIcon'>;

export function TimePicker({
  className,
  classNames,
  format,
  placeholder,
  ...rest
}: TimePickerProps) {
  return (
    <AntdTimePicker
      {...rest}
      format={format ?? 'HH:mm'}
      placeholder={placeholder ?? 'HH:mm'}
      suffixIcon={<ClockIcon size={14} aria-hidden />}
      className={[styles.picker, className].filter(Boolean).join(' ')}
      classNames={{
        ...classNames,
        popup: {
          root: [styles.popup, (classNames as { popup?: { root?: string } })?.popup?.root]
            .filter(Boolean)
            .join(' '),
        },
      }}
    />
  );
}
